import React from "react";
import { Image, Upload, message, Button, Flex, Space, Modal, Checkbox } from "antd";
import ImgList from './list';

export default () => { 


    return (
        <div>
            <h2>素材中心</h2>
            <ImgList />
        </div>
    );
};